import "core-js/modules/es.regexp.exec.js";
var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Checkbox, Form, Icon, Row } from '@digitools/honest-react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import { getCookie, setCookie } from '../../utils/cookieUtils';
import { Col } from '@digitools/honest-react/dist/lib/components/Col';
import useTealium from '../../hooks/useTealium';
import { TEALIUM_EVENT } from '../../constants/tealiumConstants';
import { useRef } from 'react';
import FocusLock from 'react-focus-lock';
import { FocusOn } from 'react-focus-on';
var StyledOverlay = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background: rgba(0, 0, 0, 0.85);\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  position: fixed;\n  text-align: center;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 99;\n"], ["\n  align-items: center;\n  background: rgba(0, 0, 0, 0.85);\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  position: fixed;\n  text-align: center;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  z-index: 99;\n"])));
var StyledCloseIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  right: 40px;\n  top: 40px;\n"], ["\n  position: absolute;\n  right: 40px;\n  top: 40px;\n"])));
var StyledToothIcon = styled(Icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 70px;\n  font-weight: bold;\n"], ["\n  font-size: 70px;\n  font-weight: bold;\n"])));
var StyledItemsContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 4rem;\n  max-width: 60rem;\n"], ["\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 0 4rem;\n  max-width: 60rem;\n"])));
var StyledCol = styled(Col)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex: auto;\n  flex-direction: column;\n"])));
var IntroTextHeader = styled.h1(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: #ccffff;\n  line-height: 3.375rem;\n  font-weight: 400;\n  font-size: 3.25rem;\n  margin-top: 0.5rem;\n"], ["\n  color: #ccffff;\n  line-height: 3.375rem;\n  font-weight: 400;\n  font-size: 3.25rem;\n  margin-top: 0.5rem;\n"])));
var StyledParagraph = styled.p(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: #00ffff;\n  font-size: 2.125rem;\n  line-height: 2.125rem;\n"], ["\n  color: #00ffff;\n  font-size: 2.125rem;\n  line-height: 2.125rem;\n"])));
var CheckBoxLabel = function () {
  return _jsx("span", __assign({
    style: {
      fontSize: '1rem',
      fontWeight: 500,
      color: 'white',
      maxWidth: '36rem',
      lineHeight: '1.5',
      marginBottom: '4rem'
    }
  }, {
    children: "Don't show me this message again"
  }));
};
var RegistrationOverlay = function () {
  var NEW_REGISTRATION_COOKIE = 'acknowledgeNewRegistration';
  var _a = useState(false),
    shouldDisplay = _a[0],
    setShouldDisplay = _a[1];
  var location = useLocation();
  var formApiRef = useRef();
  var setFormApi = function (formApi) {
    formApiRef.current = formApi;
  };
  var trackEvent = useTealium().trackEvent;
  useEffect(function () {
    var displayBanner = location.pathname === '/login' && (queryString.parse(location.search).utm_source === 'hub2' && queryString.parse(location.search).utm_medium === 'web' && queryString.parse(location.search).utm_campaign === 'DentistPortal' || queryString.parse(location.search).utm_source === 'DPP' && queryString.parse(location.search).utm_medium === 'secure' && queryString.parse(location.search).utm_campaign === 'DentistPortal') && getCookie(NEW_REGISTRATION_COOKIE) !== 'true';
    setShouldDisplay(displayBanner);
  }, [location.pathname, location.search]);
  var closeOverlay = function (register) {
    var _a;
    var optout = (_a = formApiRef.current) === null || _a === void 0 ? void 0 : _a.getValue('optout');
    optout && setCookie(NEW_REGISTRATION_COOKIE, 'true');
    trackEvent({
      event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
      event_name: register ? 'Register' : 'Close',
      event_type: TEALIUM_EVENT.EVENT_TYPE.WELCOME_OVERLAY,
      event_status: optout ? "Don't show me this message again" : ''
    });
    setShouldDisplay(false);
    register && window.location.assign('/dental/registration');
  };
  if (shouldDisplay) {
    return _jsx(FocusOn, {
      children: _jsx(FocusLock, __assign({
        noFocusGuards: true
      }, {
        children: _jsxs(StyledOverlay, __assign({
          "aria-describedby": 'overlay-description',
          "aria-labelledby": 'overlay-title',
          "aria-modal": true,
          id: 'welcome-overlay',
          "data-public": true,
          "data-testid": 'registration-overlay',
          role: 'dialog'
        }, {
          children: [_jsx(Button, __assign({
            "aria-label": 'Close page overlay',
            "data-testid": 'close-icon',
            onClick: function () {
              closeOverlay(false);
            },
            size: 'small'
          }, {
            children: _jsx(StyledCloseIcon, {
              name: 'close',
              color: 'grayLight',
              size: 'large'
            })
          })), _jsxs(StyledItemsContainer, {
            children: [_jsx(StyledToothIcon, {
              name: 'tooth',
              color: 'white',
              size: 'extraLarge'
            }), _jsxs(IntroTextHeader, __assign({
              id: 'overlay-title'
            }, {
              children: ["Welcome! ", _jsx("br", {}), " You have arrived at the new ", _jsx("br", {}), " ", _jsx("i", {
                children: "Lincoln DentalConnect"
              }), _jsx("sup", __assign({
                style: {
                  fontSize: '1.5rem'
                }
              }, {
                children: "\u00AE"
              })), " portal"]
            })), _jsx("hr", {
              style: {
                width: '100%',
                maxWidth: '15rem',
                margin: '1.875rem 0 1rem 0',
                borderTop: 'solid 1px white'
              }
            }), _jsx(StyledParagraph, {
              children: "The original portal has been retired. Re-register with your dentist's tax ID and bookmark this new site."
            }), _jsxs(Form, __assign({
              getApi: setFormApi,
              className: 'w-50'
            }, {
              children: [_jsx(Row, __assign({
                className: 'd-flex justify-content-center mt-3'
              }, {
                children: _jsx(Col, {
                  children: _jsx(Button, __assign({
                    "aria-label": 'Go to registration page',
                    buttonType: 'secondary',
                    style: {
                      width: '14.6875rem'
                    },
                    onClick: function () {
                      closeOverlay(true);
                    }
                  }, {
                    children: "REGISTER"
                  }))
                })
              })), _jsx(Row, {
                children: _jsxs(StyledCol, {
                  children: [_jsx(Checkbox, {
                    field: 'optout',
                    label: _jsx(CheckBoxLabel, {}),
                    "aria-label": 'Opt out and do not show this message again',
                    checkboxButtonStyles: {
                      backgroundColor: 'white'
                    }
                  }), _jsx(Button, __assign({
                    "aria-label": 'Close page overlay',
                    "data-testid": 'close-button',
                    buttonType: 'text',
                    style: {
                      color: 'white',
                      textDecoration: 'underline'
                    },
                    onClick: function () {
                      closeOverlay(false);
                    }
                  }, {
                    children: "Skip"
                  }))]
                })
              })]
            }))]
          })]
        }))
      }))
    });
  } else {
    return null;
  }
};
export default RegistrationOverlay;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;